import { useRecoilValue } from 'recoil';

import { tokenState } from '@/recoil/atoms/common/auth';

const useAuth = () => {
  const token = useRecoilValue(tokenState);

  return {
    token,
  };
};

export default useAuth;
